import "@mdi/font/css/materialdesignicons.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";

import "vuetify/dist/vuetify.min.css";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "./plugins/vuetify";

import AsyncComputed from "vue-async-computed";

import Vue from "vue";
import App from "./app/App.vue";
import { router } from "@/_helpers";
import { store } from "@/_store";
import Vuetify from "vuetify";
import "bootstrap";
import {tools} from "@/_helpers";
import i18n from './i18n'

// Helpers (tools) disponibles dans tous les composants
// =================
Vue.mixin({
  methods: {
    ...tools
  }
})



Vue.use(Vuetify, {
  iconfont: "mdi" || "fa" || "md" || "fa4",
   theme: {
    // primary: '#ffd403',
    primary: '#f1e341',
    secondary: '#fb5858',
    // accent: '',
    error: '#fb5858'
  }
});

Vue.component(
  "newimage",
  require("./components/modals-form/modal-newimage.vue")
);

Vue.use(AsyncComputed);

Vue.config.productionTip = false;

// integration server sentry
// import * as Sentry from "@sentry/browser";
// import * as Integrations from "@sentry/integrations";

// Sentry.init({
//   dsn: process.env.VUE_APP_SENTRY,
//   integrations: [
//     new Integrations.Vue({
//       Vue,
//       attachProps: true
//     })
//   ]
// });

window.App = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
